import { createContext, useContext, useState } from "react";

const AdminAuthContext = createContext(null);
export const useAdminAuth = () => useContext(AdminAuthContext);

export function AdminAuthProvider({ children }) {
  const [adminToken, setAdminToken] = useState("");
  const [adminUnlocked, setAdminUnlocked] = useState(false);
  return (
    <AdminAuthContext.Provider value={{ adminToken, setAdminToken, adminUnlocked, setAdminUnlocked }}>
      {children}
    </AdminAuthContext.Provider>
  );
}
